import * as go from 'gojs';
import { BACK_LAYER_NAME, FRONT_LAYER_NAME } from './config';
import { sendToBack } from './send-to-back';

const $ = go.GraphObject.make;

export const setupBringToBackFront = (
  diagram: go.Diagram,
  frontLayerPredecessorName?: string,
  backLayerPredecessorName?: string,
  zOrderProp?: string,
  layerProp?: string,
) => {
  const frontLayer = $(go.Layer, { name: FRONT_LAYER_NAME });
  const backLayer = $(go.Layer, { name: BACK_LAYER_NAME });

  const backPredecessorLayer =
    (backLayerPredecessorName && diagram.findLayer(backLayerPredecessorName)) || diagram.findLayer('Grid');
  const frontPredecessorLayer =
    (frontLayerPredecessorName && diagram.findLayer(frontLayerPredecessorName)) || diagram.findLayer('Foreground');

  if (backPredecessorLayer) {
    diagram.addLayerAfter(backLayer, backPredecessorLayer);
  }
  if (frontPredecessorLayer) {
    diagram.addLayerAfter(frontLayer, frontPredecessorLayer);
  }
  return registerModelChangedListener(diagram, zOrderProp || '', layerProp || '');
};

const registerModelChangedListener = (diagram: go.Diagram, zOrderProp: string, layerProp: string) => {
  const modelChangedListener = sendToBackGroupOnGrouping(diagram, zOrderProp, layerProp);
  diagram.addModelChangedListener(modelChangedListener);

  return () => {
    diagram.removeModelChangedListener(modelChangedListener);
  };
};

const sendToBackGroupOnGrouping =
  (diagram: go.Diagram, zOrderProp: string, layerProp: string) => (e: go.ChangedEvent) => {
    if (e.propertyName !== 'group') {
      return;
    }

    if (e.object) {
      const node = diagram.findNodeForData(e.object);
      const group = diagram.findNodeForKey(e.newValue);
      if (group && node?.layerName === BACK_LAYER_NAME) {
        sendToBack(group, zOrderProp, layerProp);
      }
    }
  };
